"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoleModal = void 0;
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var clsx_1 = __importDefault(require("clsx"));
function RoleModal() {
    var t = (0, react_i18next_1.useTranslation)().t;
    var roles = [
        { name: t('settings:TEAM_MEMBER.ROLES.ADMIN'), permissions: [true, true, true, true, true, true, true, true] },
        {
            name: t('settings:TEAM_MEMBER.ROLES.AUTOMATION_SPECIALIST'),
            permissions: [false, false, false, true, true, true, true, true],
        },
        {
            name: t('settings:TEAM_MEMBER.ROLES.MODERATOR'),
            permissions: [false, false, false, false, true, true, true, false],
        },
        {
            name: t('settings:TEAM_MEMBER.ROLES.SPECTATOR'),
            permissions: [false, false, false, false, false, false, true, true],
        },
        {
            name: t('settings:TEAM_MEMBER.ROLES.NO_ACCESS'),
            permissions: [false, false, false, false, false, false, false, false],
        },
    ];
    var permissions = [
        t('settings:TEAM_MEMBER.MODAL.PERMISSIONS.MANAGE_TEAM_MEMBERS'),
        t('settings:TEAM_MEMBER.MODAL.PERMISSIONS.MANAGE_API_WEBHOOK'),
        t('settings:TEAM_MEMBER.MODAL.PERMISSIONS.CSV_IMPORTER'),
        t('settings:TEAM_MEMBER.MODAL.PERMISSIONS.MANAGE_RULES_LISTS'),
        t('settings:TEAM_MEMBER.MODAL.PERMISSIONS.MODERATE'),
        t('settings:TEAM_MEMBER.MODAL.PERMISSIONS.SEARCH'),
        t('settings:TEAM_MEMBER.MODAL.PERMISSIONS.SEE_OVERVIEW'),
    ];
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "user-role-modal" },
            react_1.default.createElement("h3", null, t('settings:TEAM_MEMBER.MODAL.TITLE')),
            react_1.default.createElement("p", null, t('settings:TEAM_MEMBER.MODAL.TEXT1')),
            react_1.default.createElement("p", null, t('settings:TEAM_MEMBER.MODAL.TEXT2')),
            react_1.default.createElement("table", null,
                react_1.default.createElement("tbody", null,
                    react_1.default.createElement("tr", null,
                        react_1.default.createElement("th", null, t('settings:TEAM_MEMBER.MODAL.TABLE_HEADER')),
                        roles.map(function (role, index) { return (react_1.default.createElement("th", { key: index }, role.name)); })),
                    permissions.map(function (permission, indexPerm) { return (react_1.default.createElement("tr", { key: "permission".concat(indexPerm) },
                        react_1.default.createElement("td", null, permission),
                        roles.map(function (role, indexRole) { return (react_1.default.createElement("td", { key: "role".concat(indexPerm).concat(indexRole), className: (0, clsx_1.default)({ allowed: role.permissions[indexPerm] }) }, role.permissions[indexRole])); }))); }))),
            react_1.default.createElement("p", { dangerouslySetInnerHTML: { __html: t('settings:TEAM_MEMBER.MODAL.TEXT3') || '' } }))));
}
exports.RoleModal = RoleModal;
